<template>
  <div
    id="honor"
    class="honor-content"
  >
    <title-bar
      :title-prev="true"
      title-light="荣耀"
      title="资质"
      desc="多种荣誉证书已获得司法认可"
    ></title-bar>
    <div class="honor-items wrap">
      <honor-item
        v-for="(item, index) in honorItems"
        :key="index"
        :name="item.name"
        :img="item.img"
        :vertical="item.vertical"
      ></honor-item>
    </div>
  </div>
</template>

<script>
import TitleBar from '@/components/TitleBar'
import HonorItem from './components/HonorItem'
import HonorImg01 from '@/assets/images/honor/3a.png'
import HonorImg02 from '@/assets/images/honor/tongjidiaocha.png'
import HonorImg03 from '@/assets/images/honor/haiyangjingji.png'
import HonorImg04 from '@/assets/images/honor/shewaidiaocha.jpg'
import HonorImg05 from '@/assets/images/honor/tongjigeren.jpg'
import HonorImg06 from '@/assets/images/honor/shijia.png'

export default {
  name: 'HonorContent',
  data () {
    return {
      honorItems: [{
        img: HonorImg01,
        name: '3A级诚信经营示范单位证书',
        vertical: true
      }, {
        img: HonorImg02,
        name: '统计调查会员单位'
      }, {
        img: HonorImg03,
        name: '海洋经济浙江省行业协会二等奖证书'
      }, {
        img: HonorImg04,
        name: '涉外调查许可证'
      }, {
        img: HonorImg05,
        name: '先进个人'
      }, {
        img: HonorImg06,
        name: '十佳机构'
      }]
    }
  },
  components: {
    TitleBar,
    HonorItem
  }
}
</script>

<style lang="less" scoped>
.honor-content {
  padding-bottom: 122px;
  .title-bar {
    padding: 60px 0;
  }
  .honor-items {
    display: flex;
    flex-flow: wrap;
    justify-content: space-between;
    .honor-item {
      margin-top: 30px;
    }
  }
}
</style>
